<template>
  <div>
    <div class="inner-content">
      <h2>{{ $t('notification') }}</h2>
      <div class="news-area">
        <ul>
          <li v-for="item in pageOfItems" :key="item.id">
            <p class="txt-date">{{ item.sending_time }}</p>
            <p class="txt-news" data-private>
              <a :class="[(isLinkFile(item) ? 'icon_document' : ''), (item.viewed_flg == 0 ? 'font-weight-bold' : '')]" href="javascript:;" @click="onShow(item)">
                {{ item.title }}
              </a>
            </p>
          </li>
        </ul>
      </div>
      <div class="pager-area">
        <Pagination :items="listNotification" v-on:changePage="changePage" :initialPage="1" :pageSize="pageSize"/>
      </div>
    </div>
    <Spinner :isLoading="isLoading"/>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex"
import Pagination from '@/js/components/Common/Pagination'
import Spinner from '@/js/components/Spinner'
export default {
  components: {
    Pagination, Spinner
  },
  data() {
    return {
      listNotification: [],
      isLoading: false,
      pageOfItems: [],
      pageSize: 10,
      windowHeight: 0,
    }
  },
  computed: {
    ...mapState({
      notificationsRegion: state => state.notification.notificationsRegion,
    })
  },
  async created() {
    this.screenTracking(this.$t('notice_list'))
    this.isLoading = true
    await this.$store.dispatch('notification/getNotifications', 'region')
      .catch(err => {
        err.response.status == 401 ? this.$router.push('/404') : null
        return
      })
    this.listNotification = this.notificationsRegion
    this.isLoading = false
  },
  async mounted() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  methods: {
    isLinkFile (item) {
      if(!item.content && item?.files?.length == 1) {
        return true
      }
      return false
    },
    handleResize() {
      this.windowHeight = $(window).height()
      //50: header
      //67: title 27 + margin 40
      //40: padding
      //76: item 56 + margin 20 
      //43: paginate
      //43: footer
      let newsAreaHeight = this.windowHeight - 50 - 67 - 40 - 43 - 43
      this.pageSize = Math.floor(newsAreaHeight/76) > 10 ? 10 : Math.floor(newsAreaHeight/76)
    },
    changePage(pageOfItems) {
      this.pageOfItems = pageOfItems
    },
    async onShow(item) {
      let numberNoticeUnread = this.notificationsRegion.filter(notice => notice.viewed_flg == 0).length
      if (item.viewed_flg == 0) {
        if (numberNoticeUnread == 1) {
          this.$store.dispatch('notification/setViewedFlg', false)
        }
        this.$store.dispatch('notification/updateViewedNotification', item.id)
          .catch(err => {
            err.response.status == 401 ? this.$router.push('/404') : null
            return
          })
        item.viewed_flg = 1
      }
      if(this.isLinkFile(item)) {
        window.open(item.files[0].access_url, '_blank');
      }
      else {
        this.$router.push({ path: '/notifications/region/'+item.id })
      }
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize)
    }
  }
}
</script>